import { Star } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { View, XStack, YStack } from "tamagui";
import { PrimaryCheck } from "../../../core/components/PrimaryCheck";
import { Block } from "../../../ui/Block";
import type { InfoRowItemProps } from "../../../ui/InfoRow";
import { Label } from "../../../ui/Label";
import { EditorRenderInline } from "../../../ui/YooptaEditor";
import { RatingsInput, RatingUsers } from "../../elements/rating/RatingUI";
import type LocationModel from "../LocationModel";
import LocationModuleModel from "../LocationModuleModel";
import { useNavigateToLocation } from "../LocationModuleUI";

export const LocationUI = observer(({ data }: { data: LocationModel }) => {
  const navigateToLocation = useNavigateToLocation();

  const module =
    data.module instanceof LocationModuleModel ? data.module : undefined;

  const isSelected = module?.data.selectedLocations?.some(
    (location) => data.uid === location,
  );

  const infoRowItems = useMemo<InfoRowItemProps[]>(() => {
    if (!module) {
      return [];
    }

    const items = [
      {
        icon: Star,
        text: (
          <RatingUsers ratingsManager={module.ratings} dataUid={data.uid} />
        ),
      },
    ];

    return items;
  }, [module, data.uid]);

  if (!module) {
    return null;
  }

  return (
    <Block
      onPress={() =>
        navigateToLocation({
          dataUid: data.uid,
          planUid: data.plan.uid,
          moduleUid: module.uid,
        })
      }
      grouped
      infoRowItems={infoRowItems}
      opacity={!module.isDone || isSelected ? 1 : 0.5}
    >
      <YStack width="100%" gap="$small">
        <XStack
          gap={"$medium"}
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          {data.isInDoneResult && (
            <View marginTop={4}>
              <PrimaryCheck />
            </View>
          )}
          {data.data.label ? (
            <Label flex={1}>{data.data.label}</Label>
          ) : undefined}
          <RatingsInput
            withAverage
            size={24}
            ratings={module.ratings}
            dataUid={data.uid}
            disabled={module.isDone}
          />
        </XStack>
        {data.data.descriptionYooptaEditor ? (
          <EditorRenderInline
            numberOfLines={1}
            value={data.data.descriptionYooptaEditor}
          />
        ) : undefined}
      </YStack>
    </Block>
  );
});
